<template>
	<section class="filters">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="filters__wrapper">
						<div class="filter">
							<input
								class="filter__input"
								id="all"
								type="radio"
								value=""
								v-model="currentFilter"
								name="filter"
							 	checked
							 >
							<label class="filter__label" for="all">{{$t('filters.all')}}</label>

							<input
								class="filter__input"
								id="future"
								type="radio"
								name="filter"
								value="future"
								v-model="currentFilter"
							>
							<label class="filter__label" for="future">{{$t('filters.future')}}</label>

							<input
								class="filter__input"
								id="past"
								type="radio"
								name="filter"
								value="past"
								v-model="currentFilter"
							>
							<label class="filter__label" for="past">{{$t('filters.past')}}</label>
						</div>
						<a href="/api/events/favourites/pdf/" class="filter__download"><img src="/static/img/download.svg" alt="">{{$t('pdf')}}<span class="filter__download--big">  PDF</span></a>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		data () {
			return {
				currentFilter: ''
			}
		},
		watch: {
			currentFilter () {
				this.$store.commit('setMyEventsFilter', this.currentFilter)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.filters {
		padding: 25px 0;
		background-color: #aa9f8b;
		&__wrapper {
			display: flex;
			justify-content: space-between;
		}
	}

	.filter {
		display: flex;
		&__input {
			position: absolute;
			left: -99999px;
			opacity: 0;
			cursor: pointer;
			&:checked + .filter__label {
				background-color: #fff;
			}
		}
		&__label {
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			font-family: $lato-bold;
			font-size: 14px;
			letter-spacing: 0.05em;
			text-transform: uppercase;
			height: 25px;
			padding: 0 10px;
			margin-right: 10px;
		}
		&__download {
			display: flex;
			align-items: center;
			font-size: 14px;
			text-decoration: none;
			color: $black;
			img {
				margin-right: 15px;
			}
			&--big {
				font-family: $lato-bold;
				margin-left: 5px;
			}
		}
	}

	@media (max-width: 991.98px) {
		.filter {
			&__download {
				display: none;
			}
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) and (max-width: 767.98px) {

	}

	// Medium devices (tablets, 768px and up)
	@media (min-width: 768px) and (max-width: 991.98px) {

	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
	}

	// Extra large devices (large desktops, 1200px and up)
	@media (min-width: 1200px) {
	}
</style>



// WEBPACK FOOTER //
// src/components/MyEventsList/FiltersComponents.vue